<template>
    <button class="{outline:none}:focus-visible mx:auto w:100% max-width:320 h:48 r:8 bg:y300 bg:gray300:disabled f:gray800 cursor:pointer translateY(1px):active">
        <slot></slot>
    </button>
</template>
